export type JenisPersetujuanLayananDarah =
  | "transfusi"
  | "inkompatibel"
  | "plebotomi";

export interface OpsiPersetujuanLayananDarah {
  jenis: JenisPersetujuanLayananDarah;
  title: string;
  tabLabel: string;
  icon: string;
  accessCode: string;
  suketKey: string;
}

export const PERSETUJUAN_LAYANAN_DARAH: OpsiPersetujuanLayananDarah[] = [
  {
    jenis: "transfusi",
    title: "Persetujuan Transfusi Darah",
    tabLabel: "Transfusi Darah",
    icon: "mdi-blood-bag",
    accessCode: "persetujuan_transfusi_darah",
    suketKey: "persetujuan-transfusi-darah"
  },
  {
    jenis: "inkompatibel",
    title: "Persetujuan Transfusi Darah Inkompatibel",
    tabLabel: "Transfusi Darah Inkompatibel",
    icon: "mdi-alert-octagon-outline",
    accessCode: "persetujuan_transfusi_inkompatibel",
    suketKey: "persetujuan-transfusi-inkompatibel"
  },
  {
    jenis: "plebotomi",
    title: "Persetujuan Plebotomi",
    tabLabel: "Plebotomi",
    icon: "mdi-needle",
    accessCode: "persetujuan_plebotomi",
    suketKey: "persetujuan-plebotomi"
  }
];

export const SUKET_KEYS_LAYANAN_DARAH: string[] = PERSETUJUAN_LAYANAN_DARAH.map(
  opsi => opsi.suketKey
);

export const HUBUNGAN_PERSETUJUAN_DARAH = [
  { value: "diri_sendiri", text: "Diri Sendiri" },
  { value: "istri", text: "Isteri" },
  { value: "suami", text: "Suami" },
  { value: "anak", text: "Anak" },
  { value: "ibu", text: "Ibu" },
  { value: "ayah", text: "Ayah" },
  { value: "lainnya", text: "Lainnya" }
];

export const CHECKLIST_PLEBOTOMI = [
  {
    key: "tujuan_indikasi",
    label: "Tujuan / Indikasi tindakan plebotomi terapi"
  },
  {
    key: "jumlah_darah",
    label: "Perkiraan jumlah darah yang akan diambil"
  },
  {
    key: "tata_cara",
    label: "Tata cara pelaksanaan tindakan plebotomi terapi"
  },
  {
    key: "risiko_komplikasi",
    label:
      "Risiko dan komplikasi yang mungkin terjadi (antara lain pusing, lemas, pingsan, penurunan tekanan darah, memar / hematoma dan nyeri pada tempat tusukan, serta infeksi)"
  },
  {
    key: "tindakan_luar_dugaan",
    label:
      "Tindakan lain yang diberikan jika dokter menemukan sesuatu yang diluar dugaan"
  },
  {
    key: "hasil_tidak_sesuai",
    label:
      "Tindakan ini bisa memberikan hasil yang tidak sesuai harapan meskipun sudah dilakukan sesuai prosedur yang berlaku"
  }
];

export const BAGIAN_PENYAKIT_OPTIONS = [
  "Anak",
  "Bedah",
  "Kebidanan/Kandungan",
  "Penyakit Dalam",
  "Lain-lain"
];

export function opsiBagianPenyakit(nilaiTersimpan: string | null | undefined): string[] {
  const nilai = nilaiTersimpan ? String(nilaiTersimpan).trim() : "";
  if (!nilai || BAGIAN_PENYAKIT_OPTIONS.indexOf(nilai) >= 0) {
    return BAGIAN_PENYAKIT_OPTIONS;
  }
  return [...BAGIAN_PENYAKIT_OPTIONS, nilai];
}
